var phone_number = {};
module['exports'] = phone_number;
phone_number.formats = require("./formats");



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/zh_CN/phone_number/index.js
// module id = 1393
// module chunks = 0